import React from 'react';
import { NumericInput } from '@gafe/common-ui';

import styles from './ProductQuantity.module.scss';

export type Props = {
  title?: string;
  subtitle?: string;
  units: string;
  quantity: number;
  selectQuantity: (quantity: number) => void;
};

export const ProductQuantity = ({
  title = 'Select Quantity:',
  subtitle,
  units,
  quantity,
  selectQuantity,
}: Props) => {
  return (
    <div className={styles.wrapper} data-testid="product-quantity">
      <p className={styles.subtitle}>
        <span className={styles.title}>{title}</span> <br />
        {subtitle}
      </p>
      <div className={styles.quantity_row}>
        {/* Replacing <QuantitySelector> component with Common UI <NumericInput /> due to SALE-6609*/}
        <NumericInput
          allowLeadingZeros={false}
          allowNegative={false}
          decimalScale={0}
          fixedDecimalScale
          onChange={e => selectQuantity(Number(e))}
          placeholder={`- ${units}`}
          suffix={units}
          thousandSeparator=","
          value={quantity && Number(quantity) > 0 ? quantity : ''}
          width="lg"
        />
      </div>
    </div>
  );
};
